import log from 'loglevel';

import { TrialBannerStage } from './getTrialBannerStage';

export const TRIAL_BANNER_DISMISS_KEY_PREFIX = 'trial_banner_dismissed';
export const TRIAL_BANNER_DISMISS_KEY_SEPARATOR = ':';

// Only CALM/WARNING are adjournable — URGENT/EXPIRED are decisions that
// cannot be deferred, so they never persist a dismissal.
const DISMISSIBLE_STAGES: ReadonlySet<TrialBannerStage> = new Set([
  TrialBannerStage.CALM,
  TrialBannerStage.WARNING,
]);

export interface TrialBannerDismissKeyParams {
  userId: string;
  stage: TrialBannerStage;
  daysLeft: number;
}

export function isTrialBannerDismissible(stage: TrialBannerStage): boolean {
  return DISMISSIBLE_STAGES.has(stage);
}

// Keyed by stage + daysLeft (not just stage) so a dismissal only covers the
// exact banner the user closed — it reappears once the countdown moves on.
export function buildTrialBannerDismissKey({
  userId,
  stage,
  daysLeft,
}: TrialBannerDismissKeyParams): string {
  return [TRIAL_BANNER_DISMISS_KEY_PREFIX, userId, stage, daysLeft].join(
    TRIAL_BANNER_DISMISS_KEY_SEPARATOR,
  );
}

export function readTrialBannerDismissed(key: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.localStorage.getItem(key) !== null;
  } catch (err) {
    log.error('readTrialBannerDismissed', err);
    return false;
  }
}

export function writeTrialBannerDismissed(key: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(key, String(Date.now()));
  } catch (err) {
    log.error('writeTrialBannerDismissed', err);
  }
}
